module.exports = require('../dist/components/Box/Box');
